export class CustomerVM {
    AddressTitle: string;
    City: string;
    State: string;
    PhoneNumber: string;
    Landmark: string = "";
    ZipCode: string;
    IsDefault: boolean = false;
    AddressNote: string = "";
    UserId: number;
    Id: number;
    Country: string = "";
    IsSelected: boolean = false;
    Street: string;
    Quantity: number;
}
export class CustomerAddressList {
    CustomerList: Array<CustomerVM> = [];
}
export class CityStateModel {
    geoPostalCode: string;
    geoCity: string;
    geoCounty: string;
    geoState: string;
    postalCode: string;
}
export class AddressDataModel
{
    id: number;
    addressTitle: string;
    city: string;
    state: string;
    country: string;
    phoneNumber: string;
    landmark: string;
    addressNote: string;
    isDefault: boolean;
    userId: number
    zipCode: string;
    pageNumber: number
    pageSize: number;
    street: string;
}

export class AddressModel {
    Id: number;
    AddressTitle: string;
    City: string;
    State: string;
    Country: string;
    PhoneNumber: string;
    Landmark: string;
    AddressNote: string;
    IsDefaultString: string;
    IsDefault: boolean;       
    ZipCode: string;
    PageNumber: number;
    PageSize: number;
}


 export class OrderListVM {
    PageNumber: number = 1;
    PageSize: number = 10 ;
    StartDate: string;
    EndDate: string;
    ProductId: number;
 }

 export class CustomerAllOrderListVM {
    addressId: number;
    addressNote: string;
    addressTitle: string;
    city: string;
    country: string;
    dateFormatted: string;
    discount: string;
    isShowDiscount: boolean;
    landmark: string;
    orderId: number;
    orderStatus: string;
    paymentId: number;
    price: number;
    productId: number;
    productName: string;
    productTitle: string;
    state: string;
    totalPrice: number;
    userId: number;
    zipcode: string;
    imageLoader: boolean = true;
    fileTitle: string;
    productImage: string;
 }

 export class AllOrderList {
    CustomerOrdeList:  Array<CustomerAllOrderListVM> = [];
    TotalPages: number;
 }

 export class CustomerOrderDetail{
    id:number; 
    orderId:string;
    userId:number;
    productId:number;
    price:number;
    dateFormatted:string;
    addressId:number;
    addressTitle:string;
    city:string;
    state:string;
    country:string;
    landmark:string;
    addressNote:string;
    zipcode:number;
    productName:string;
    productTitle:string;
    totalPrice:number;
    discount:number;
    discountFormatted : string;
    isShowDiscount:boolean;
    paymentId:number;
    orderStatus:number;
    isDiscount: boolean = false;
    warrantyServiceTerm: string;
    warrantyYear: string;
    duration: string;
    title: string;
    installationPrice: string;
    warrantyPrice: string;
    applicationInstallationPrice: string;
    warrantyId: string;
    taxRate: number;
    priceFormatted: string;
    totalPriceFormatted : string;
    discountedPriceFormatted : string;
    deliveryPrice: string;
    rateId: string;
    shipmentId: string;
    transactionId: string;
    street: string;
    taxRateFormatted: string;
    taxAmountFormatted: string;
    trackingNumber: string;
    trackingStatus: string;
    finalPriceFormatted:string;
    grandTotalPriceFormatted: string;
 }
 export class CustomerOrderDetails{
     id:number;
 }

 export class AdminOrderListVM {
     PageNumber: number = 1;
     PageSize: number = 10;
     ProductId: number;
     StartDate: string;
     EndDate: string;
     OrderStatus: string;
     Keyword: string;
 }

 export class OrderStatusVM {
     id: number
     OrderStatus: string;
 }

 export class ProductWarrantyItem {
    ProductId: number;
}

 export class ErrorMessageModel {
    messages: string;
}

export class UpdateDeliveryPriceVM {
    Id: number;
    DeliveryPrice: string;
}